import { useReducer } from 'react'
import { useAlert } from 'react-alert'
import { updateDescription } from '../../../../../main/usecases/Import-files'
import { useModalBox } from '../../../../contexts'
import Button from '../../../button'
import Input from '../../../input'
import * as S from './styles'

const InputModal = ({ item }: any) => {
  const { modalClose } = useModalBox()
  const alert = useAlert()
  const descriptionReducer = (state: any, action: any) => {
    switch (action.type) {
      case 'set':
        return action.newState
      default:
        return ''
    }
  }
  const [description, dispatchD] = useReducer(
    descriptionReducer,
    item.descricao
  )
  return (
    <S.Wrapper>
      <Input
        type="text"
        name="description"
        value={description}
        onChange={(e: any) => {
          dispatchD({ type: 'set', newState: e.target.value })
        }}
      ></Input>
      <Button
        onClick={() => {
          try {
            updateDescription().update({
              cdUpload: item.cdUpload,
              uploadAt: item.uploadAt,
              descricao: description,
              status: item.status,
              type: item.type,
              path: item.path,
              url: item.url
            })
            alert.show('Sucesso em mudar a descrição', {
              type: 'success',
              timeout: 4000
            })
            modalClose()
          } catch (error) {
            alert.show('falha ao mudar a descrição', {
              type: 'error',
              timeout: 4000
            })
          }
        }}
      >
        Salvar
      </Button>
    </S.Wrapper>
  )
}
export default InputModal
